// Message code define
export const FileMessageCode = {
  upload: '100200',
}

// Endpoint
export const FileEndPoint = {
  upload: 'drive/v1/file/upload',
}
